import React from "react"
import Button from "../shared/button/text-button"
import PropTypes from "prop-types"
import { nextPage } from "../../redux/actions/journey-actions"
import { connect } from "react-redux"
import * as classnames from "classnames"

import "./summary-buttons.scss"

const SummaryButtons = ({
  selectedBenefits,
  numberOfSwappableBenefits,
  onEmptyBasket,
  submit
}) => {
  return (
    <div className="summary-button-container">
      <div className="empty-button">
        <Button text="Empty basket" onClick={onEmptyBasket} />
      </div>
      <div
        className={classnames("confirm-button", {
          "disable-submit": numberOfSwappableBenefits > selectedBenefits.length
        })}
      >
        <Button text="Confirm selection" onClick={submit} />
      </div>
    </div>
  )
}

SummaryButtons.propTypes = {
  selectedBenefits: PropTypes.array,
  numberOfSwappableBenefits: PropTypes.number,
  submit: PropTypes.func.isRequired,
  onEmptyBasket: PropTypes.func.isRequired
}

const mapStateToProps = _ => ({})

const mapDispatchToProps = dispatch => ({
  // submit: () => dispatch(submitResults())
  submit: () => dispatch(nextPage())
})

export default connect(mapStateToProps, mapDispatchToProps)(SummaryButtons)
